module.exports = __webpack_public_path__ + "img/bronze-6.19716695.jpg";